<template>
  <div class="indexPage">
    <van-sticky>
      <van-row class="p-header">
        <van-col span="4" class="title">首页</van-col>
        <van-col span="17" class="search">
          <van-search
            shape="round"
            v-model="taskName"
            placeholder="请输入搜索关键词"
            @search="onSearch"
          />
        </van-col>
        <van-col
          span="3"
          class="icon"
          @click="$router.push({ path: '/news', query: { tab: 2 } })"
        >
          <van-icon name="bell" :badge="unReadMessage" />
        </van-col>
      </van-row>
    </van-sticky>
    <div class="banner">
      <van-image v-if="bannerDefault" :src="banner" fit="cover" />
      <van-swipe v-else :autoplay="3000" indicator-color="white">
        <van-swipe-item
          v-for="(banner, index) in indexBannerArray"
          :key="index"
        >
          <van-image
            :src="iconPath + banner.pic"
            @click="toPoster(banner)"
            fit="cover"
          />
        </van-swipe-item>
      </van-swipe>
    </div>

    <van-row class="modules">
      <van-col span="8" v-for="(item, index) in modules" :key="index">
        <router-link :to="item.path" class="item">
          <van-image
            width="1.44rem"
            height="1.44rem"
            fit="contain"
            :src="item.icon"
          />
          <p>{{ item.text }}</p>
        </router-link>
      </van-col>
    </van-row>

    <div class="main-section">
      <div class="list" :gutter="12" v-if="taskList.length">
        <van-cell class="header" value="更多" is-link to="/tasksList">
          <template #title> <van-icon name="fire" />热门任务 </template>
        </van-cell>
        <a
          href="javascript:void(0);"
          v-for="(item, index) in taskList"
          @click="handleDetail(item)"
          :key="'taskItem' + index"
          class="index_task_item"
        >
          <div class="title">
            <div class="price">
              {{ item.taskMoney == "费用面议" ? "" : item.amount }}
              <span
                :class="{
                  only:
                    item.amount == undefined ||
                    item.amount.length == 0 ||
                    item.taskMoney == '费用面议',
                }"
              >
                <template v-if="item.taskMoney == '费用面议'"
                  >费用面议</template
                >
                <template v-else-if="item.taskMoney == '固定价格'"
                  >/元</template
                >
                <template v-else-if="item.taskMoney == '按月'">元/月</template>
                <template v-else-if="item.taskMoney == '按周'">元/周</template>
                <template v-else-if="item.taskMoney == '按天'">元/天</template>
                <template v-else-if="item.taskMoney == '按时'"
                  >元/小时</template
                >
              </span>
            </div>
            <span class="hot" v-if="index < 3">热</span>
            <span class="name">{{ item.ecompanyJobCategoryName }}</span>
          </div>
          <div class="desc" v-html="item.taskName"></div>
          <div class="city">
            <span class="time">发布时间:{{ sliceData(item.publishDate) }}</span>
            地点:{{ item.cityName ? item.cityName : "不限" }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Sticky,
  Row,
  Col,
  Search,
  Icon,
  Image,
  Cell,
  Swipe,
  SwipeItem,
  Notify,
  Dialog
} from "vant";
import api from "@/api/list";
import { getToken } from "@/utils/auth";
export default {
  components: {
    [Sticky.name]: Sticky,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Image.name]: Image,
    [Cell.name]: Cell,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Notify.name]: Notify,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
       id:null,
      ename:'',
      certificationFlag:1,
      iconPath: process.env.VUE_APP_FILE_PATH,
      banner: require("./assets/banner.png"),
      bannerDefault: true,
      indexBannerArray: [],
      indexPosetAreaCode: "index",
      taskList: [],
      token:getToken(),
      taskName: "",
      unReadMessage: 0,
      modules: [
        {
          id: 0,
          icon: require("./assets/icon_agreement.png"),
          text: "个体户注册",
          path: "/individual_list",
        },
        {
          id: 1,
          icon: require("./assets/icon_cooperation.png"),
          text: "合作项目",
          path: "/myTasksList",
        },
        {
          id: 2,
          icon: require("./assets/icon_individual.png"),
          text: "我的协议",
          path: "/individual_contractList",
        }
      ],
    };
  },
  created() {
 //   this.checkIndividualBusinessStatus();
    //获取任务列表
    api.hotTaskList().then((res) => {
      if (res.data.status == "200") {
        this.taskList = res.data.data;
      }
    });

    if (getToken()) {
      //获取未读消息条数
      api.unReadMessage().then((res) => {
        if (res.data.status == "200" && res.data.data) {
          this.unReadMessage = res.data.data;
        }
      });
    }

    //广告位
    this.initPoster();
  },
  methods: {
     async checkIndividualBusinessStatus(){
         await api.checkIndividualBusinessStatus().then((res) => {
         if (res.data.status == "200") {
            this.id=res.data.data.id;
            if(res.data.data.ename!=null){
                this.ename=res.data.data.ename;
            }
            if(res.data.data.flag!=null){
              this.certificationFlag=res.data.data.flag;
              this.ocompanyId = res.data.data.ocompanyId;
                  //  1  不弹框  2 未认证或身份证认证失败，实名认证失败 跳转到身份证认证页面  3 实名认证成功，活体检测失败，跳转到活体检测页面
                //  4 签名为空，跳转到签名页面  5 跳转到个体户列表页  6. 活体认证失败，跳转到个体户明细页面
              if(this.ename){
                if(this.certificationFlag!=1){
                  Dialog.alert({
                      title: '温馨提示',
                      message: this.ename+'提醒您，尽快完成个体户注册和认证！',
                      messageAlign: 'left',
                      confirmButtonText: '开始认证',
                      beforeClose: this.beforeClose
                  })
                }
              }
            }
         }
      });
     } ,
    beforeClose(action, done) {
      if (action === 'confirm') {
        // done(false) 阻止弹窗关闭
         //  1  不弹框  2 未认证或身份证认证失败，实名认证失败 跳转到身份证认证页面  3 实名认证成功，活体检测失败，跳转到活体检测页面
        //  4 签名为空，跳转到签名页面  5 跳转到个体户列表页
         let toUrl="/individual_identity" ; // 身份证认证页面
         if(this.certificationFlag==3){
           toUrl="/individual_video"; // 活体检测页面
         }
         if(this.certificationFlag==4){
             toUrl="/individual_signature"; // 跳转到签名页面
         }
         if(this.certificationFlag==5){
             toUrl="/individual_list"; // 跳转到个体户列表页
         }
         if(this.certificationFlag==6){ // 活体检测失败，跳转到个体户明细页面
             toUrl="/individual_info";
         }
        this.$router.push({
          path: toUrl,
          query: {
              id:this.id
          }
        });
        done();
      } else {
        done(false);
      }
    },
    onSearch() {
      this.$router.push({
        path: "/tasksList",
        query: {
          taskName: this.taskName,
        },
      });
    },
    initPoster() {
       //debugger
      if(getToken()){
        //debugger
        api
          .contentPosterlistToActiveUser({}, { subUrl: this.indexPosetAreaCode })
          .then((res) => {
          if (res.data.status == "200") {
            if (
              res.data.data &&
              typeof res.data.data != "undefined" &&
              res.data.data.length > 0
            ) {
              this.indexBannerArray = res.data.data;
              this.bannerDefault =
                this.indexBannerArray.length > 0 ? false : true;
            }
          } else {
            this.$notify({
              message: res.data.message,
              type: "danger",
              duration: 2000,
            });
          }
        });
      }else{
        api
          .contentPosterlistToNoLoginUser({}, { subUrl: this.indexPosetAreaCode })
          .then((res) => {
          if (res.data.status == "200") {
            if (
              res.data.data &&
              typeof res.data.data != "undefined" &&
              res.data.data.length > 0
            ) {
              this.indexBannerArray = res.data.data;
              this.bannerDefault =
                  this.indexBannerArray.length > 0 ? false : true;
            }
          } else {
            this.$notify({
              message: res.data.message,
              type: "danger",
              duration: 2000,
            });
          }
        });
      }
    },
    toPoster(item) {
      if (item.url == undefined) {
        return false;
      } else if (
        item.url &&
        (item.url.startsWith("http://") || item.url.startsWith("https://"))
      ) {
        window.open(item.url);
      } else {
        this.$router.push(item.url);
      }
    },
    handleDetail(item) {
      if (item.isApply) {
        this.$router.push({ path: "/myTasksDetail", query: { id: item.id } });
      } else {
        this.$router.push({ path: "/tasksDetail", query: { id: item.id } });
      }
    },
    sliceData(data) {
      if (data && data.length == 10) {
        return data.slice(5);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.indexPage {
  margin: -46px 0 10px;
  .p-header {
    background: #fff;
    line-height: 46px;
    text-align: center;
    .title {
      font-size: 18px;
      font-weight: 600;
    }

    .search {
      .van-search {
        padding: 6px 0;
      }
    }

    .icon {
      position: relative;
      font-size: 24px;
      color: #6275f0;
      top: 2px;
      .van-info {
        top: 6px;
        right: 2px;
      }
    }
  }

  .main-section {
    padding: 0 8px;

    .header {
      padding: 10px;
      font-weight: 600;
      border-radius: 4px;
      .van-icon-fire {
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 3px;
        color: #f06262;
        font-size: 18px;
      }

      .van-cell__value {
        margin-right: -6px;
        font-weight: 400;
      }
    }

    .list {
      .index_task_item {
        display: block;
        background: #fff;
        margin-top: 2px;
        border-radius: 4px;
        padding: 16px;
        color: #666;
        font-size: 12px;
        line-height: 24px;

        &:active {
          background: #dadef9;
        }

        & > div {
          height: 24px;
        }

        .title {
          font-size: 14px;
          color: #333;
          font-weight: 600;
          margin-bottom: 2px;
          .hot {
            background: #f06262;
            color: #fff;
            font-size: 11px;
            padding: 0 2px;
            margin-right: 3px;
            line-height: 16px;
            border-radius: 2px;
            margin-top: -3px;
            vertical-align: middle;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          }
          .price {
            float: right;
            color: #f3852c;
            font-size: 14px;
            span {
              font-size: 10px;
              margin-left: -2px;
              &.only {
                font-size: 14px;
              }
            }
          }
        }

        .city {
          font-size: 10px;
          color: #999;
          margin-top: 6px;
          .time {
            float: right;
          }
        }
      }
    }
  }
}
.banner {
  display: block;
  margin: 8px;
  border-radius: 0.12rem;
  overflow: hidden;
  box-shadow: 0 0 0.32rem rgba(0, 0, 0, 0.05);

  .van-image {
    display: block;
    width: 100%;
    height: 156px;
    border-radius: 0.12rem;
    overflow: hidden;
  }
}

.modules {
  background: #fff;
  margin: 8px;
  border-radius: 4px;
  .item {
    display: block;
    padding: 0.32rem 0 0.5rem;
    text-align: center;
    p {
      color: #999;
      font-size: 0.2933rem;
      margin-top: -0.08rem;
    }
  }
}
</style>


